import React from "react";
import {
  getProficiencyLabel,
  sortLanguagesByProficiency,
} from "../../genericFunctions/languageProficiencies";

const LanguageItem = (props) => {
  const languages = props.languages;
  const profileLanguage = props.language;

  if (languages === undefined || languages.length === 0) {
    return <div></div>;
  } else {
    return sortLanguagesByProficiency(languages).map((language) => {
      return (
        <div
          key={language.name}
          style={{
            display: "flex",
            alignItems: "left",
            flexDirection: "column",
          }}
        >
          <p style={{ fontSize: "1.25rem", marginBottom: "0px" }}>
            {language.name}{" "}
          </p>
          <p>{getProficiencyLabel(language.proficiency, profileLanguage)}</p>
        </div>
      );
    });
  }
};

export default LanguageItem;
